import React, { useState } from 'react';
import messages from '../../displayMessages';
import { useLayoutSize, WrappedMessage } from 'utils';
import CareerFilterTag from './CareerFilterTag';
import CareerRadioButton from '../CareerRadioButton/CareerRadioButton';
import { CareerSearchRequestOrderingEnum } from 'labxchange-client';
import { intl } from 'i18n';
import { Icon } from 'elements';

const sortOptions = [
  {
    id: CareerSearchRequestOrderingEnum.AlphabeticalAsc,
    label: intl.formatMessage(messages.alphabeticalAZSortLabel),
  },
  {
    id: CareerSearchRequestOrderingEnum.AlphabeticalDesc,
    label: intl.formatMessage(messages.alphabeticalZASortLabel),
  },
  {
    id: CareerSearchRequestOrderingEnum.SalaryDesc,
    label: intl.formatMessage(messages.salaryHighToLowSortLabel),
  },
  {
    id: CareerSearchRequestOrderingEnum.SalaryAsc,
    label: intl.formatMessage(messages.salaryLowToHighSortLabel),
  },
];

interface SortDropdownProps {
  selectedSortOrder: any;
  onSelectOption: (option: any) => void;
  onCloseDropdown?: () => void;
}

const SortDropdown: React.FC<SortDropdownProps> = ({
  selectedSortOrder,
  onSelectOption,
  onCloseDropdown,
}) => {
  const isMobile = ['small', 'mobile'].includes(useLayoutSize());

  return (
    <div className='sort-dropdown'>
      {isMobile && (
        <div className='header sort-header'>
          <button className='close-button' onClick={onCloseDropdown}>
            <Icon name='career-close' fill={'#497595'} zoom='1.5em' />
          </button>
          <h5 className='title'>
            <WrappedMessage message={messages.mobileSortDropdownLabel} />
          </h5>
          {/* This is just a transparent placeholder to align title center */}
          <div className='close-button transparent'>
            <Icon name='career-close' fill='transparent' zoom='1.5em' />
          </div>
        </div>
      )}
      <div className='sort-list'>
        {sortOptions.map((option, index) => (
          <CareerRadioButton
            key={index}
            id={option.id}
            selected={option.id === selectedSortOrder}
            onClick={() => onSelectOption(option)}
            disablePulse
          >
            {option.label}
          </CareerRadioButton>
        ))}
      </div>
    </div>
  );
};

interface CareerSortProps {
  selectedSortOrder: any;
  onSelectOption: (optionId: any) => void;
}

const CareerSort: React.FC<CareerSortProps> = ({
  selectedSortOrder,
  onSelectOption,
}) => {
  const [isDropdownOpen, setIsDropdownOpen] = useState(false);
  const [sortLabel, setSortLabel] = useState(
    intl.formatMessage(messages.alphabeticalAZSortLabel)
  );
  const isMobile = ['small', 'mobile'].includes(useLayoutSize());

  const toggleDropdown = () => {
    setIsDropdownOpen(!isDropdownOpen);
  };

  const onSelectOptionClick = (option: any) => {
    onSelectOption(option.id);
    setSortLabel(option.label);
    if (!isMobile) {
      setIsDropdownOpen(false);
    }
  };

  return (
    <div className='sort-container'>
      <span className='sort-label'>
        <WrappedMessage message={messages.sortCareersButtonLabel} />
      </span>
      <CareerFilterTag onClick={toggleDropdown} isDropdownOpen={isDropdownOpen}>
        {sortLabel}
      </CareerFilterTag>
      {isDropdownOpen && (
        <SortDropdown
          selectedSortOrder={selectedSortOrder}
          onSelectOption={onSelectOptionClick}
          onCloseDropdown={toggleDropdown}
        />
      )}
      {isDropdownOpen && (
        <div className='dropdown-overlay' onClick={toggleDropdown} />
      )}
    </div>
  );
};

export default CareerSort;
